import React, { Component } from 'react';

//componentes
import BoletinAction from './boletin'

class Index extends Component {

    render(){
        return(
            <div>
                <BoletinAction />
            </div>
        );
    }

}
export default Index;